import { CommandType } from "../../../../common/services/cqs/CommandType";
import { GeometryBaseCommand } from "./GeometryBaseCommand";
export class DeleteGeometryCommand extends GeometryBaseCommand {
    guid: string;
    typ: string;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "DeleteGeometryCommand";

    constructor(guid: string, atgardGuid: string, kontraktGuid: string, typ: string) {
        super(DeleteGeometryCommand.$type, CommandType.Delete);
        this.guid = guid;
        this.virkeskopskontraktGuid = kontraktGuid;
        this.virkeskopsatgardGuid = atgardGuid;
        this.typ = typ;
    }
}
